import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['flashAlert', 'alertMsg']
  static values = { msg: { type: String, default: 'Alert' } }

  connect() {
    // We create an alert region first and then populate the alert with text after a delay
    setTimeout(() => {
      this.alertMsgTarget.innerText = this.msgValue
      this.flashAlertTarget.classList.remove('visually-hidden')
    }, 250);
  }
}